import { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faTrash, faSave, faCancel, faBedPulse } from '@fortawesome/free-solid-svg-icons';
import useUtils from '../../../utiles/useUtiles';
import './ModalDetailsTemplate.css';

interface Props {
    templateId: number, 
    show: boolean, 
    handleClose: () => void
}

const ModalDetailsTemplate: React.FC<Props> = ( { templateId, show, handleClose } ) => {

    const [loading, setLoading] = useState<boolean>( false );
    const [templateDetails, settemplateDetails] = useState<any | null>( null );
    const { axiosRequest, baseUrl, toastInstance } = useUtils()
    const axios = axiosRequest();
    const toast = toastInstance();

    useEffect( () => {
        if ( templateId ) {
            fetchTemplate();
        }
    }, [templateId] );

    const fetchTemplate = async () => {
        setLoading( true );
        const request = await axios.get( `${baseUrl()}/templates/${templateId}` );
        setLoading( false );
        const { error, result, message } = request.data;

        if ( error ) {
            toast.error( message );
        } else {
            settemplateDetails( result );
        }
    };
    

    return (
        <Modal size="lg" show={show} onHide={handleClose} backdrop="static">
            <Modal.Header>
                <Modal.Title>Template Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-12">
                        <div className="cardCustom p-3">
                            <div className="d-flex mb-2">
                                <div className="w-50">
                                    <div className='d-flex align-items-center gap-10'>
                                        <label className='mb-0'>Name:</label>
                                        <h6 className='mb-0'><strong>{templateDetails?.name}</strong></h6>
                                    </div>
                                </div>

                                <div className="w-50">
                                    <div className='d-flex align-items-center gap-10'>
                                        <label className='mb-0'>Status:</label>
                                        {
                                            templateDetails?.status == 1 ? (
                                                <span className='mb-0 status-active'>Active</span>
                                            ): (
                                                <span className='mb-0 status-inactive'>Inactive</span>
                                            )
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                            
                            <div className="row">
                                <div className="col-md-12">
                                    <h6>Headers:</h6>
                                    <hr />
                                </div>
                                {/* <div className="col-md-6">
                                    <h6>Template Type Headers</h6>
                                    <div className='d-flex flex-column'>
                                    {
                                        templateDetails?.collumnMapping && templateDetails?.collumnMapping.map((e, index) => (
                                            <span key={index} className='header-element'>{e['csvTypeColumnName']}</span>
                                        ))
                                    }
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <h6>Template Headers</h6>
                                    <div className='d-flex flex-column'>
                                    {
                                        templateDetails?.collumnMapping && templateDetails?.collumnMapping.map((e, index) => (
                                            <span key={index} className='header-element'>{e['templateColumnName']}</span>
                                        ))
                                    }
                                    </div>
                                </div> */}

                                <div className="mb-3 col-md-12 d-flex flex-nowrap justify-content-between">
                                    <div className="w-50">
                                        <h6>Template Type Headers</h6>
                                    </div>
                                    <div className="w-50">
                                        <h6>Template Headers</h6>
                                    </div>
                                </div>
                                <div className='w-100 mh-200 custom-scroll'>
                                {
                                    templateDetails?.collumnMapping && templateDetails?.collumnMapping.map( ( e: any, index: number ) => (
                                        <div className="mb-3 col-md-12 d-flex flex-nowrap justify-content-between" key={index}>
                                            <div className="w-50">
                                                <span className='header-element'>{e['csvTypeColumnName']}</span>
                                            </div>
                                            <div className="w-50">
                                                <span className='header-element'>{e['templateColumnName']}</span>
                                            </div>
                                        </div>
                                    ) )
                                } 
                                </div>


                                {/* <div className="mb-3 col-md-12 d-flex flex-nowrap justify-content-between">
                                    <div className="w-50">
                                        <h6>Template Type Headers</h6>
                                    </div>
                                    <div className="w-50">
                                        <h6>Template Headers</h6>
                                    </div>
                                </div>
                                {
                                    templateDetails?.collumnMapping && templateDetails?.collumnMapping.map((e, index) => (
                                        <div className="mb-3 col-md-12 d-flex flex-nowrap justify-content-between" key={index}>
                                            <span>{e['csvTypeColumnName']}</span>
                                            <span>{e['templateColumnName']}</span>
                                        </div>
                                    ))
                                } */}
                                
                                {/* <div className="col-md-12">
                                    <label>Headers:</label>
                                    <h6>{templateDetails?.collumnMapping && templateDetails?.collumnMapping.map(e => e['templateColumnName']).join(', ')}</h6>
                                </div> */}
                            </div>
                            
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-center d-flex flex-nowrap gap-3">
                <button type="button" className="btn btn-md revrex-outline-btn mt-3" onClick={handleClose}>
                    <span>Close</span>
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalDetailsTemplate;